import React from 'react';
import { PostalCodeElement } from 'react-stripe-elements';
import { withStripeStyle } from 'housecall-ui/dist/core/StripeCardElements/StripeElementStyle';
import PropTypes from 'prop-types';

const StripePostalCodeElement = ({ onChange, onFocus, onBlur, cardElementStyle, placeholder, value }) => (
  <PostalCodeElement
    onChange={onChange}
    onFocus={onFocus}
    onBlur={onBlur}
    options={{ style: cardElementStyle }}
    placeholder={placeholder}
    value={value}
  />
);
export default withStripeStyle()(StripePostalCodeElement);

StripePostalCodeElement.propTypes = {
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  cardElementStyle: PropTypes.objectOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};
